import type { ComponentType } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Home from "./bundles/home/components/Home";
import Product from "./bundles/product/components/Product";

export const ROUTES = {
  HOME: "/",
  HOME_COMPANY: "/empresa",
  PRODUCT: "/produto",
  PRODUCT_COMPANY: "/produto/empresa",
} as const;

type RouteGroup = {
  Component: ComponentType;
  paths: readonly string[];
};

const routeGroups: readonly RouteGroup[] = [
  {
    Component: Home,
    paths: [ROUTES.HOME, ROUTES.HOME_COMPANY],
  },
  {
    Component: Product,
    paths: [ROUTES.PRODUCT, ROUTES.PRODUCT_COMPANY],
  },
];

function AppRoutes() {
  return (
    <Routes>
      {routeGroups.flatMap(({ Component, paths }) =>
        paths.map((path) => (
          <Route key={path} path={path} element={<Component />} />
        ))
      )}

      <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
    </Routes>
  );
}

export default AppRoutes;
